/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

// External Package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

// Style
import style from "./navbar.module.scss";
import { BALE_THEME_URL } from "../../source/links";
import { useTranslation } from "../../i18n";

export default function NavMobileMode() {
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const { t } = useTranslation();

  // Function
  const getNavItemClass = (path: string) => {
    return window.location.pathname === path
      ? `${style.nav_distance} font-vietnam-400 ${style.border_bottom_active}`
      : `${style.nav_distance} font-vietnam-400`;
  };
  const toggleOffcanvas = () => {
    setIsOffcanvasOpen(!isOffcanvasOpen);
  };
  return (
    <div>
      <button
        className="btn"
        onClick={toggleOffcanvas}
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
      <div
        className={`offcanvas offcanvas-end ${isOffcanvasOpen ? "show" : ""} `}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
        tabIndex={-1}
      >
        <div className="offcanvas-header d-flex justify-content-between">
          <a className="navbar-brand font-federicka font-size-30" href="/">
            Bale's
          </a>{" "}
          <button
            type="button"
            className="btn"
            onClick={toggleOffcanvas}
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav">
            <li
              className={`nav-item m-0 ${getNavItemClass(
                "/"
              )} font-vietnam-400`}
            >
              <a className="nav-link active" aria-current="page" href="/">
                {t.nav.home}
              </a>
            </li>
            <li
              className={`nav-item m-0 ${getNavItemClass(
                "/about"
              )} font-vietnam-400`}
            >
              <a className="nav-link" href="/about">
                {t.nav.about}
              </a>
            </li>
            <li
              className={`nav-item m-0 ${getNavItemClass(
                "/services"
              )} font-vietnam-400`}
            >
              <a className="nav-link" href="/services">
                {t.nav.services}
              </a>
            </li>
            <li
              className={`nav-item m-0 ${getNavItemClass(
                "/history-job"
              )} font-vietnam-400`}
            >
              <a className="nav-link" href="/history-job">
                {t.nav.journey}
              </a>
            </li>
            <li
              className={`nav-item m-0 ${getNavItemClass(
                "/contact"
              )} font-vietnam-400`}
            >
              <a className="nav-link" href="/contact">
                {t.nav.contact}
              </a>
            </li>
            <li className={`nav-item m-0 ${style.nav_distance} font-vietnam-400`}>
              <a
                className="nav-link"
                href={BALE_THEME_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.nav.templates}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
